import usePrefix from '@/hooks/usePrefix';
import { Button } from 'antd';
import { useRouter } from 'next/router';
import React from 'react';

export default function MemberCredits({ credits }) {
  const router = useRouter();
  const prefix = usePrefix();

  return (
    <>
      {credits && credits?.length > 0 && (
        <div className="border border-primary rounded-md overflow-hidden mb-8">
          <div className="text-sm text-primary bg-orange-50 border-b border-primary  flex flex-row items-center w-full relative p-3">
            <span className="ml-2">Credits</span>
          </div>
          {credits?.map((credit, index) => (
            <div
              className="p-4 flex flex-col gap-y-2 md:flex-row items-center justify-between"
              key={index}
            >
              <p>{credit.facility_name}</p>
              <p>${credit.keep_amount}</p>
              <Button
                type="primary"
                className="uppercase"
                onClick={() => {
                  router.push(
                    `${prefix}/myreservation/Reservation/${credit.reservation_id}`
                  );
                }}
              >
                View Reservation
              </Button>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
